import { createSelector } from 'reselect';
import { equals, prop } from 'ramda';

const localState = prop('auth');

export const getIsAuthenticated = createSelector(
  localState,
  prop('authenticated'),
);

export const getIsAuthLoading = createSelector(
  getIsAuthenticated,
  equals(null),
);
